// extracted by mini-css-extract-plugin
export default {"container":"Box--container--eced7d","section":"Box--section--c4b4ba","separator":"Box--separator--5f825c"};